var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import classNames from 'classnames';
import { formatAsPositivePoundsOrPence } from '../../../utils/format-currency';
import { TextLink } from '../../TextLink';
import { PromotionDescription } from './PromotionDescription';
import { MyWaitrose, ChevronRightBold } from '../../../foundations/icons';
import styles from './PromotionElement.module.scss';
export var PromotionElement = memo(function (_a) {
    var _b;
    var currentSaleUnitPrice = _a.currentSaleUnitPrice, promotion = _a.promotion, productId = _a.productId, highlightColor = _a.highlightColor, withChevron = _a.withChevron;
    var myWaitrosePromotion = promotion.myWaitrosePromotion, promotionDescription = promotion.promotionDescription, promotionSubText = promotion.promotionSubText;
    var amount = currentSaleUnitPrice.price.amount;
    var price = formatAsPositivePoundsOrPence(amount);
    var dataAttributes = {
        'data-actiontype': 'redirect',
        'data-origincomponent': 'PromotionElement',
        'data-shortdescription': "view products in ".concat(promotionDescription, " offer"),
        'data-testid': 'link-offer',
    };
    return (React.createElement("div", { className: styles.promotion, id: "".concat(productId, "_").concat(promotion.promotionId), "data-testid": "promotion-element" },
        React.createElement(TextLink, __assign({ size: "large" }, dataAttributes, promotion.linkProps, { className: classNames(styles.promoLink, (_b = {},
                _b[styles.backgroundRed] = highlightColor === 'red',
                _b[styles.backgroundGreen] = highlightColor === 'green',
                _b[styles.withSubText] = !!promotionSubText,
                _b)), rel: "nofollow" }),
            myWaitrosePromotion && React.createElement(MyWaitrose, null),
            React.createElement(PromotionDescription, { price: price, promotion: promotion, color: highlightColor }),
            highlightColor && withChevron && (React.createElement(ChevronRightBold, { size: "xsmall", "data-testid": "chevron-right", className: styles.chevronIcon })))));
});
//# sourceMappingURL=PromotionElement.js.map